export default __webpack_public_path__ + "static/media/delete.0cdd2394.svg";